import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import {
  getIngestFieldPlaceholder,
  normalizeDriveQueryInput,
} from '../../utils/composioTrigger';
import DriveQueryHelpHint from './DriveQueryHelpHint';
import styles from './IngestDriveQueryField.module.scss';

const IngestDriveQueryField = ({
  field,
  value,
  onChange,
  disabled = false,
  className = '',
}) => {
  const trimmed = String(value ?? '').trim();
  const normalizedPreview = (() => {
    if (!trimmed) return '';
    const normalized = normalizeDriveQueryInput(trimmed);
    return normalized !== trimmed ? normalized : '';
  })();

  if (!field) return null;

  const placeholder = getIngestFieldPlaceholder(field);
  return (
    <Box className={`${styles.fieldBlock} ${className}`.trim()}>
      <Box className={styles.fieldLabelRow}>
        <Typography component="label" className={styles.fieldLabel}>
          {field.label || 'Query'}
          {field.required ? ' *' : ''}
        </Typography>
        <DriveQueryHelpHint field={field} />
      </Box>
      <TextField
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        fullWidth
        size="small"
        className={styles.input}
        disabled={disabled}
        multiline
        minRows={2}
        required={field.required}
        aria-label={field.label || 'Query'}
      />
      {normalizedPreview && (
        <Typography variant="caption" color="text.secondary" className={styles.preview}>
          Sent as: <code>{normalizedPreview}</code>
        </Typography>
      )}
    </Box>
  );
};
export default IngestDriveQueryField;
